<template>
  <el-dropdown
    class="dropdown"
    trigger="click"
    :class="isShowColorChange && isShow ? 'show': ''"
    @command="handleCommand"
    @visible-change="handelVisibleChange"
  >
    <div class="label-container">
      <span class="label">{{ selectedLabel }}</span>
      <i class="dropdown-arrow" :class="arrow"></i>
    </div>
    <el-dropdown-menu slot="dropdown">
      <el-dropdown-item
        v-for="(item, index) in data"
        class="dropdown-item"
        :class="isShowColorChange && item.value == value ? 'active' : ''"
        :key="index"
        :command="item.value"
        :disabled="item.disabled"
        :divided="item.divided"
      >
        {{ item.label || $t(item.labelI18nKey) }}
      </el-dropdown-item>
    </el-dropdown-menu>
  </el-dropdown>
</template>

<script>
import _ from 'lodash'

export default {
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    value: {
      require: true
    },
    empty: {
      type: String,
      default: ''
    },
    data: {
      type: Array,
      required: true
    },
    arrow: {
      type: String,
      default: 'el-icon-arrow-down'
    },
    activeArrow: {
      type: String,
      default: 'el-icon-arrow-down'
    },
    isShowColorChange: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      isShow: false
    }
  },
  computed: {
    selectedLabel () {
      const selected = _.find(this.data, { value: this.value })
      if (selected) {
        return selected.selectedLabel || selected.label || this.$t(selected.labelI18nKey)
      } else {
        return this.empty
      }
    }
  },
  created () {

  },
  methods: {
    handleCommand (selected) {
      const item = _.find(this.data, item => item.value === selected)
      if (item && item.disabled) {
        return
      }
      this.$emit('change', selected)
    },
    handelVisibleChange (visible) {
      if (visible) {
        this.isShow = true
      } else {
        this.isShow = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.dropdown {
  .label-container {
    cursor: pointer;

    .dropdown-arrow {
      margin-left: 5px;
    }
  }
}

.show {
  .label-container {
    color: #808080;
  }
}

.dropdown-item.active {
  color: #0096cc
}
.dropdown-item.is-disabled {
  cursor: not-allowed;
  pointer-events: auto;
}
</style>
